<h1 mat-dialog-title>{{ pageTitle }}</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div class="form-wrapper mt-3">
    <div class="alert alert-primary text-center mb-4" *ngIf="!loggedUserMaster">
      <mat-slide-toggle class="toggle-activation-btn" color="accent" [checked]="enableEdit"
        (change)="onToggleSelected($event)" matTooltipPosition="right"
        matTooltip="{{ 'companies.detail.contractTab.toggleTooltip' | translate }}">
        <mat-label>{{ 'companies.detail.contractTab.toggleLabel' | translate }}</mat-label>
      </mat-slide-toggle>
    </div>
    <form [formGroup]="form" (ngSubmit)="onFormSubmit(model)">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
      <div class="row mb-1">
        <div class="col-12 col-md-6 text-left">
          <a mat-button mat-raised-button mat-default (click)="onClose()">{{ 'common.cta.close' | translate }}</a>
        </div> <!-- /.col -->
        <div class="col-12 col-md-6 text-right">
          <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate" *ngIf="!loggedUserMaster">
          </mat-spinner-button>
        </div> <!-- /.col -->
      </div> <!-- /.row -->
    </form>
  </div> <!-- /.form-wrapper -->
</mat-dialog-content> <!-- mat-dialog-content -->
